import { Row, Col, Card } from 'antd';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  SafetyCertificateOutlined,
  ExperimentOutlined,
  BuildOutlined,
  EnvironmentOutlined,
  FileProtectOutlined,
  HomeOutlined,
  ToolOutlined,
  AppstoreOutlined
} from '@ant-design/icons';
import s from './index.module.css';
import { getIndexModule } from '../../server/api';

const MODULE_CONFIG = {
  B03A01: {
    id: 4,
    smallTitle: '计量',
    icon: <ExperimentOutlined />,
    color: '#eb2f96',
    modelTitle1: '计量服务机构',
    modelDesc1: '专业的计量检测机构，为您提供权威的计量保障',
    modelTitle2: '计量知识',
    modelDesc2: '了解计量相关法规知识，提升质量管理水平',
    modelTitle3: '计量专家',
    modelDesc3: '专业的计量技术团队，为您提供权威的技术支持',
    showCategory: true,
  },
  B03A02: {
    id: 5,
    smallTitle: '标准化',
    icon: <BuildOutlined />,
    color: '#722ed1',
    showCategory: false,
  },
  B03A03: {
    id: 3,
    smallTitle: '认证认可',
    icon: <SafetyCertificateOutlined />,
    color: '#fa8c16',
    modelTitle1: '认证认可机构',
    modelDesc1: '专业的认证认可服务机构，为您提供权威的质量保障',
    modelTitle2: '认证认可知识',
    modelDesc2: '了解认证认可相关法规知识，提升质量管理水平',
    modelTitle3: '认证认可专家',
    modelDesc3: '专业的认证认可团队，为您提供权威的技术支持',
    showCategory: true,
  },
  B03A04: {
    id: 2,
    smallTitle: '检验检测',
    icon: <ToolOutlined />,
    color: '#52c41a',
    modelTitle1: '检验检测机构',
    modelDesc1: '专业的检验检测服务机构，为您提供权威的检测保障',
    modelTitle2: '检验检测知识',
    modelDesc2: '了解检验检测相关法规知识，提升质量管理水平',
    modelTitle3: '检验检测专家',
    modelDesc3: '专业的检验团队，为您提供权威的技术支持',
    showCategory: true,
  },
  B03A05: {
    id: 6,
    smallTitle: '知识产权',
    icon: <FileProtectOutlined />,
    color: '#13c2c2',
    modelTitle1: '知识产权机构',
    modelDesc1: '专业的知识产权机构，为您提供权威的产权保障',
    modelTitle2: '产权知识',
    modelDesc2: '了解产权相关法规知识，提升质量管理水平',
    modelTitle3: '产权专家',
    modelDesc3: '专业的知识产权技术团队，为您提供权威的技术支持',
    showCategory: true,
  },
  B03A06: {
    id: 1,
    smallTitle: '质量管理',
    icon: <SafetyCertificateOutlined />,
    color: '#1A509A',
    modelTitle1: '质量管理机构',
    modelDesc1: '专业的质量管理服务机构，为您提供权威的质量保障',
    modelTitle2: '质量管理知识',
    modelDesc2: '了解质量管理相关法规知识，提升质量管理水平',
    modelTitle3: '质量管理专家',
    modelDesc3: '专业的质量管理团队，为您提供权威的技术支持',
    showCategory: true,
  },
  B03A07: {
    id: 7,
    smallTitle: '仪器设备',
    icon: <HomeOutlined />,
    color: '#f5222d',
    showCategory: false,
  },
  B03A08: {
    id: 8,
    smallTitle: '视频培训',
    icon: <AppstoreOutlined />,
    color: '#faad14',
    showCategory: false,
  },
};

// 静态导出，供列表页等做 code 查找
export const modules = [
  { title: '质量管理服务', code: 'B03A06', ...MODULE_CONFIG.B03A06 },
  { title: '检验检测机构', code: 'B03A04', ...MODULE_CONFIG.B03A04 },
  { title: '认证认可服务', code: 'B03A03', ...MODULE_CONFIG.B03A03 },
  { title: '计量服务', code: 'B03A01', ...MODULE_CONFIG.B03A01 },
  { title: '标准化服务', code: 'B03A02', ...MODULE_CONFIG.B03A02 },
  { title: '知识产权服务', code: 'B03A05', ...MODULE_CONFIG.B03A05 },
  { title: '仪器设备共享', code: 'B03A07', ...MODULE_CONFIG.B03A07 },
  { title: '视频培训服务', code: 'B03A08', ...MODULE_CONFIG.B03A08 },
];

const ServiceModules = ({ onModuleChange }) => {
  const history = useHistory();
  const [moduleList, setModuleList] = useState([]);
  const [currentModule, setCurrentModule] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const loadModules = async () => {
      try {
        const res = await getIndexModule();
        const result = res.data?.result;
        if (Array.isArray(result)) {
          const merged = result
            .filter((item) => MODULE_CONFIG[item.code])
            .map((item) => ({
              title: item.name,
              code: item.code,
              orderNum: item.orderNum,
              ...MODULE_CONFIG[item.code],
            }))
            .sort((a, b) => a.orderNum - b.orderNum);
          setModuleList(merged);
        }
      } catch (_) {
        // 接口失败时回退到静态数据
        setModuleList(modules);
      }
    };
    loadModules();
  }, []);

  useEffect(() => {
    if (moduleList.length > 0 && !isInitialized) {
      const defaultModule = moduleList.find((m) => m.code === 'B03A04') || moduleList[0];
      setCurrentModule(defaultModule);
      if (onModuleChange) {
        onModuleChange(defaultModule, null);
      }
      setIsInitialized(true);
    }
  }, [moduleList, isInitialized]);

  const getModulePath = (id) => {
    const paths = {
      1: '/brand-building',
      2: '/inspection-institution',
      3: '/certification',
      4: '/measurement',
      5: '/standardization',
      6: '/intellectual-property',
      7: '/equipment-sharing',
      8: '/video-training'
    };
    return paths[id] || '/';
  };

  const handleModuleClick = (module) => {
    if (!currentModule || currentModule.id === module.id) return;

    const slideDirection = module.id > currentModule.id ? 'right' : 'left';

    if (module.id === 8) {
      const path = getModulePath(module.id);
      history.push(path);
    } else {
      setCurrentModule(module);
      if (onModuleChange) {
        onModuleChange(module, slideDirection);
      }
    }
  };

  return (
    <div className={s.serviceModules}>
      <Row gutter={[16, 16]} justify="center">
        {moduleList.map((module) => (
          <Col xs={12} sm={8} md={6} lg={3} key={module.code}>
            <Card
              className={`${s.moduleCard} ${currentModule?.id === module.id ? s.moduleCardActive : ''}`}
              hoverable
              onClick={() => handleModuleClick(module)}
              bodyStyle={{ padding: '6px 16px' }}
            >
              <div className={s.moduleContent}>
                <div
                  className={s.moduleIcon}
                  style={{ color: module.color }}
                >
                  {module.icon}
                </div>
                <div className={`${s.moduleTitle} ${currentModule?.id === module.id ? s.moduleTitleActive : ''}`}>{module.title}</div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ServiceModules;
